import Image from 'library/components/image';
import {
  Content,
  Text,
  ItemContainer,
  Item,
  LeftContainer,
  ImageContainer,
  ItemText,
  DeleteItemIconContainer,
  DeleteItemIcon, BelowContainer, BelowTitle, BelowText,
} from './styles';
import withForm from './hocs/with-form-container';

function add3Dots(string, limit) {
  const dots = '...';
  if (string.length > limit) {
    // eslint-disable-next-line no-param-reassign
    string = string.substring(0, limit) + dots;
  }
  return string;
}

const UpdateModal = ({
  text,
  data = [],
  onDeselect,
  fieldProps: {
    component: NestedInput,
    ...fieldProps
  },
  name,
  defaultValue,
  hint,
  label,
}) => {
  const renderItem = ({ name: itemName, id, images = [] }) => {
    const [image] = images || [{ url: '' }];

    return (
      <Item key={id}>
        <LeftContainer>
          <ImageContainer>
            <Image name={itemName} id={id} source={image} width={50} />
          </ImageContainer>
          <ItemText>{add3Dots(itemName, 29)}</ItemText>
        </LeftContainer>
        <DeleteItemIconContainer>
          <DeleteItemIcon className="icon-trash" onClick={() => onDeselect(id)} />
        </DeleteItemIconContainer>
      </Item>
    );
  };

  return (
    <>
      <Content>
        <Text>{text}</Text>
        <ItemContainer>
          {data.map(renderItem)}
        </ItemContainer>
      </Content>
      <BelowContainer>
        <BelowTitle>{label}</BelowTitle>
        <NestedInput
          {...fieldProps}
          name={name}
          defaultValue={defaultValue}
        />
        <BelowText>{hint}</BelowText>
      </BelowContainer>
    </>
  );
};

export default withForm(UpdateModal);
